export default __webpack_public_path__ + "static/study-2-9642fb8d035090215ee718df1ea82f86.svg";